import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';

const PAYMENT_STATUS_LABELS = {
  Pending: '',
  Authorised: '',
  Completed: 'Paid',
  Cancelled: 'Cancelled',
  MaxRefunded: 'Refunded',
};

const CANCELLED_PAYMENT_STATUS_LABELS = {
  Pending: '',
  Authorised: '',
  Completed: 'Paid',
  Cancelled: 'Skipped',
  MaxRefunded: 'Credited',
};

const resolveCurrency = (currency) => ({
  EUR: '\u20AC',
  GBP: '\u00A3',
  DOLLAR: '$',
}[currency] || currency);

const StyledPackPayments = styled.table`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

const PaymentRow = styled.tr`
  font-weight: ${({ isNextPayment }) => (isNextPayment ? 600 : 400)};
  color:${({ theme, isPreviousPayment }) => (isPreviousPayment ? theme.palette.grey[2] : 'inherit')};

  &.cancelled {
    color:${({ theme, isCompletedPayment }) => (isCompletedPayment ? theme.palette.grey[2] : 'inherit')};
  }

  > td {
    padding-bottom: ${({ theme }) => theme.spacing}px;
  }
  > *:first-child {
    width: 100%;
  }

  .status {
    padding-right: ${({ theme }) => theme.spacing}px;
  }

  .amount {
    text-align: right;
  }
`;

const PackPayments = ({ className, payments, packStatus }) => {
  const classes = ['PackPayments', className];

  return (
    <StyledPackPayments className={classes.filter((c) => !!c).join(' ')}>
      <tbody>
        {payments
          .filter((p) => p.amount >= 0)
          .sort((p1, p2) => (p1.date > p2.date ? -1 : 1))
          .map((payment) => {
            const isCancelledPack = packStatus === 'Cancelled';
            const isPreviousPayment = ['Completed', 'Cancelled'].includes(
              payment.status,
            );
            const isCompletedPayment = payment.status === 'Completed';
            return (
              <PaymentRow
                key={payment.date}
                isNextPayment={payment.isNextPayment}
                isPreviousPayment={isPreviousPayment}
                isCompletedPayment={isCompletedPayment}
                className={packStatus.toLowerCase()}
              >
                <td>{moment(payment.date).format('MMMM Do YYYY')}</td>
                <td className="status">
                  {(isCancelledPack
                    ? CANCELLED_PAYMENT_STATUS_LABELS : PAYMENT_STATUS_LABELS)[payment.status]}
                </td>
                <td className="amount">
                  {resolveCurrency(payment.currency) + payment.amount}
                </td>
              </PaymentRow>
            );
          })}
      </tbody>
    </StyledPackPayments>
  );
};

PackPayments.propTypes = {
  payments: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      isNextPayment: PropTypes.bool,
    }),
  ).isRequired,
  packStatus: PropTypes.string.isRequired,
  className: PropTypes.string,
};

PackPayments.defaultProps = {
  className: null,
};

export default PackPayments;
